import { createSlice } from '@reduxjs/toolkit';
import {
    ultimoSalada,
} from '../actions/ultimoSalada';


export const UltimoSaladaReducerNodo = createSlice({
    name: 'ultimoSalada',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(ultimoSalada.pending, (state) => { state.loading = true })
            .addCase(ultimoSalada.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(ultimoSalada.rejected, (state) => { state.loading = false })
    }
})

export default UltimoSaladaReducerNodo.reducer;
